export default __webpack_public_path__ + "static/media/3.e9eb9a3d.jpg";